function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M10.14 3.86h3.72C18.35 3.86 22 7.51 22 12s-3.65 8.14-8.14 8.14h-3.72C5.65 20.14 2 16.49 2 12s3.65-8.14 8.14-8.14z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.86 16.42a4.42 4.42 0 100-8.84 4.42 4.42 0 000 8.84z"
})));